export default __webpack_public_path__ + "media/components/AdEdit/images/facebook-headlike-0bff86611918e782a5dda60c4f79959a.png";